import { useValidations } from "@sttedra_ui/framework";

import { searchValue } from "@/composables/_commons/helper.js";
import { workspacesListAll } from "@/api/workspaces/workspaces.api.js";
import { dataSourcesListAll } from "@/api/data-sources/data-sources.api.js";
import { reportTypes } from "@/composables/_commons/enums.js";
import { mapTypesListAll } from "@/api/map-types/map-types.api.js";
import { subMapTypesListAll } from "@/api/submap-types/submap-types.api.js";
import { powerBiGetReports } from "@/api/reports/reports.api.js";

const { required } = useValidations();

let workspaces;
let dataSources;
let tipoMapas;
let subtipoMapas;

// const ubicaciones = [
//   {
//     label: "Superior",
//     value: "Superior",
//   },
//   {
//     label: "Lateral",
//     value: "Lateral",
//   },
// ];

async function getWorkspaces() {
  workspaces = await workspacesListAll();
}

async function getDataSources() {
  dataSources = await dataSourcesListAll();
}

async function getMapTypes() {
  tipoMapas = await mapTypesListAll();
}

async function getSubMapTypes() {
  subtipoMapas = await subMapTypesListAll();
}

export { getWorkspaces, getDataSources, getMapTypes, getSubMapTypes };

export default function (object = null, type) {
  let guidWorkspaceRules = null;
  let uidInformeRules = null;
  let fuenteDatosDtoRules = null;
  // let ubicacionRules = null;
  let urlRules = null;
  let tipoMapaRules = null;

  if (type == reportTypes.PowerBI) {
    guidWorkspaceRules = { required };
    uidInformeRules = { required };
  }

  if (
    type == reportTypes.Tabla ||
    type == reportTypes.Grafico ||
    type == reportTypes.Mapa
  ) {
    fuenteDatosDtoRules = { required };
    // ubicacionRules = { required };
  }

  if (type == reportTypes.Mapa) {
    tipoMapaRules = { required };
  }

  if (type == reportTypes.URL) {
    urlRules = { required };
  }

  let timeout;

  return {
    items: [
      {
        field: "guidWorkspace",
        label: "Workspace",
        value: searchValue(object, "guidWorkspace"),
        rules: guidWorkspaceRules,
        type: "Dropdown",
        properties: {
          options: workspaces,
          optionValue: "guidWorkspace",
          optionLabel: "titulo",
        },
        classObj: ["col-12 md:col-6"],
        hidden: type != reportTypes.PowerBI,
      },
      {
        field: "uidInforme",
        label: "Introducir GUID",
        value: searchValue(object, "guidReportPowerBI"),
        rules: uidInformeRules,
        type: "Autocomplete",
        classObj: ["col-12 md:col-4", "guid-custom-input"],
        properties: {
          disabled: true,
          forceSelection: true,
          minLength: 2,
          optionLabel: "name",
          placeholder: "Mínimo 2 caracteres",
          suggestions: [],
          delay: 300,
        },
        hidden: type != reportTypes.PowerBI,
        events: {
          input: async ($event, updateModel) => {
            $event.stopPropagation();
            $event.preventDefault();

            const query = $event.currentTarget
              .querySelector("input")
              .value.trim();

            if (timeout) {
              clearTimeout(timeout);
            }

            timeout = setTimeout(async () => {
              let suggestions = [];

              if (query && query.length >= 2) {
                suggestions = await powerBiGetReports(query);
              }

              updateModel((model) => {
                model.properties.suggestions = suggestions;
              });
            }, 600);
          },
        },
      },
      {
        field: "newPbix",
        classObj: ["col-12 md:col-2 custom-subform"],
        hidden: type != reportTypes.PowerBI,
      },
      {
        field: "fuenteDatosDto",
        label: "Fuente de datos",
        value: searchValue(object, "fuenteDatosDto"),
        rules: fuenteDatosDtoRules,
        type: "Dropdown",
        properties: {
          options: dataSources,
          optionValue: "idFuente",
          optionLabel: "titulo",
        },
        classObj: ["col-12 md:col-4 mt-3"],
        hidden:
          type != reportTypes.Tabla &&
          type != reportTypes.Grafico &&
          type != reportTypes.Mapa,
      },
      // {
      //   field: "ubicacion",
      //   label: "Ubicación de los filtros",
      //   value: searchValue(object, "ubicacion"),
      //   rules: ubicacionRules,
      //   type: "Dropdown",
      //   properties: {
      //     options: ubicaciones,
      //     optionValue: "label",
      //     optionLabel: "value",
      //   },
      //   classObj: ["col-12 md:col-6"],
      //   hidden:
      //     type != reportTypes.Tabla &&
      //     type != reportTypes.Grafico &&
      //     type != reportTypes.Mapa,
      // },
      {
        field: "tipoMapa",
        label: "Tipo de mapa",
        value: searchValue(object, "tipoMapa"),
        rules: tipoMapaRules,
        type: "Dropdown",
        properties: {
          options: tipoMapas,
          optionValue: "idTipoMapa",
          optionLabel: "nombre",
        },
        classObj: ["col-12 md:col-6"],
        hidden: type != reportTypes.Mapa,
      },
      {
        field: "tipoSubmapa",
        label: "Subtipo de mapa",
        value: searchValue(object, "tipoSubmapa"),
        type: "Dropdown",
        properties: {
          options: subtipoMapas,
          optionValue: "idTipoSubmapa",
          optionLabel: "nombre",
          disabled: true,
        },
        classObj: ["col-12 md:col-6"],
        hidden: type != reportTypes.Mapa,
      },
      {
        field: "URL",
        label: "URL",
        value: searchValue(object, "url"),
        rules: urlRules,
        classObj: ["col-12"],
        hidden: type != reportTypes.URL,
      },
      {
        field: "tieneLandingPage",
        label: "Tiene landing page",
        value: searchValue(object, "tieneLandingPage"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12"],
        hidden: type != reportTypes.URL,
      },
      {
        field: "mostrarFiltros",
        label: "Mostrar filtros",
        value: searchValue(object, "mostrarFiltros"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
        hidden: type != reportTypes.PowerBI,
      },
      {
        field: "mostrarTabs",
        label: "Mostrar pestañas",
        value: object == null ? true : searchValue(object, "mostrarTabs"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
        hidden: type != reportTypes.PowerBI,
      },
      {
        field: "prefiltrar",
        label: "Prefiltrar",
        value: searchValue(object, "prefiltrar"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
        hidden: type != reportTypes.PowerBI,
      },
    ],
  };
}
